import styled from "styled-components";

export const StatusContainer = styled.div`
  @import url("https://fonts.googleapis.com/css2?family=Inter:wght@700&display=swap");
  width: 295px;
  height: 273.41px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-style: normal;
  font-family: "Inter" sans-serif;

  p {
    margin-top: 15px;
    font-weight: 400;
    font-size: 10px;
    line-height: 0px;
    color: #f8f9fa;
    cursor: pointer;
  }

  h1 {
    margin-top: 15px;
    font-weight: 400;
    font-size: 14px;
    line-height: 0px;
    color: #f8f9fa;
  }
  select {
    width: 265px;
    height: 38px;
    background: #343b41;
    border: 0.973899px solid #343b41;
    box-sizing: border-box;
    border-radius: 3.19783px;
    margin: 20px 0px;
    color: #868e96;
    font-style: normal;
    font-weight: 400;
    font-size: 12.9853px;
    line-height: 21px;
  }
  button {
    width: 163.09px;
    height: 38.37px;
    background: #59323f;
    border: 1.2182px solid #59323f;
    box-sizing: border-box;
    border-radius: 4px;
    font-style: normal;
    font-weight: 500;
    font-size: 12.7913px;
    line-height: 21px;
    color: #ffffff;
    cursor: pointer;
  }
`;
